import {SingleTargetRelation} from '../SingleTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import type {ISketchObject} from '../../../../../mesh/sketch/ISketchObject';

let count = 0;

/**
 * 判断对象是否为固定槽口约束。
 *
 * @param value 待判断对象。
 * @returns 是否为固定槽口约束。
 */
export function isSlotFixConstraint(value: object): value is SlotFixConstraint {
    return Reflect.get(value, 'isSlotFixConstraint') === true;
}

/**
 * 固定槽口约束（SW：Fix Slot / `swConstraintType_FIXEDSLOT`）。
 *
 * 语义（官方 Slot PropertyManager 原文）：**槽口的尺寸与位置都被固定**。
 * 因此参数求解侧把槽口全部成员点登记为固定参数（与 `Fix` 关系同一处理），
 * 拖拽侧则由槽口结构重算前的固定判定拦下。
 */
export class SlotFixConstraint extends SingleTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isSlotFixConstraint: boolean = true;

    /** 关系类型。 */
    public relationType = SketchRelationKind.FixSlot;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '固定槽口';
    }

}
